import Vue from "vue";

/**
 * Svojstva koja komponenta zaista deklariše (i preko extends/mixins), da ostalo ne završi kao
 * atributi u DOM-u kad se ekranu daju sva stanja ljuske.
 */
export const declaredProps = (component) => Object.keys(Vue.extend(component).options.props || {});
